import _extends from '@babel/runtime/helpers/extends';
import React__default, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import FormGroup from '../FormGroup/FormGroup.js';
import useId from '../../hooks/useId.js';
import Input from './Input.js';

const inputFieldPropTypes = {
  containerProps: PropTypes.shape({}),
  helperMessage: PropTypes.string,
  helperProps: PropTypes.shape({}),
  /** shorthand for labelProps={{ label }} */
  label: PropTypes.string,
  labelProps: PropTypes.shape({
    label: PropTypes.string
  }),
  name: PropTypes.string,
  intent: PropTypes.string
};
const InputField = /*#__PURE__*/forwardRef(({
  containerProps = {},
  helperMessage,
  helperProps,
  labelProps = {},
  label = labelProps?.label,
  name,
  intent,
  ...restProps
}, ref) => {
  const id = useId();
  return /*#__PURE__*/React__default.createElement(FormGroup, _extends({
    intent: intent
  }, containerProps), /*#__PURE__*/React__default.createElement(FormGroup.Label, _extends({
    htmlFor: id,
    label: label
  }, labelProps)), /*#__PURE__*/React__default.createElement(Input, _extends({
    id: id,
    name: name
  }, restProps, {
    ref: ref
  })), /*#__PURE__*/React__default.createElement(FormGroup.HelperText, helperProps, helperMessage));
});
InputField.propTypes = inputFieldPropTypes;
InputField.displayName = 'NuiInputField';
var InputField$1 = InputField;

export { InputField$1 as default };
